// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cz2.cz2 .cz2__client-image-editor-overlays{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}", ""]);
// Exports
module.exports = exports;
